export default "__VITE_ASSET__CIfV6HDb__"